// The Google tag on hannamfertility.com stores the ad click ID in the _gcl_aw
// cookie as "GCL.<timestamp>.<gclid>" on the parent domain, so it is readable
// from this app while it is embedded on www.hannamfertility.com.
const GCL_AW_COOKIE = /(?:^|;\s*)_gcl_aw=GCL\.\d+\.([^;]+)/;

// The Meta pixel stores the ad click as _fbc ("fb.1.<timestamp>.<fbclid>") and
// its browser ID as _fbp on the same parent domain.
const FBC_COOKIE = /(?:^|;\s*)_fbc=([^;]+)/;
const FBP_COOKIE = /(?:^|;\s*)_fbp=([^;]+)/;

function readCookie(pattern, cookieString) {
  try {
    const match = pattern.exec(cookieString);
    return match ? decodeURIComponent(match[1]) : null;
  } catch {
    return null;
  }
}

export function readGclidFromCookie(cookieString = document.cookie) {
  return readCookie(GCL_AW_COOKIE, cookieString);
}

export function readMetaCookies(cookieString = document.cookie) {
  return { fbc: readCookie(FBC_COOKIE, cookieString), fbp: readCookie(FBP_COOKIE, cookieString) };
}
